<template>
  <div v-if="visible.length > 0" class="pinned-banners mb-4">
    <v-alert
      v-for="item in visible"
      :key="item.rkey"
      :type="item.type"
      variant="tonal"
      closable
      class="rounded-xl border mb-3"
      @click:close="dismiss(item)"
    >
      <div class="font-weight-black mb-1">{{ item.title }}</div>
      <div class="text-body-2" style="white-space: pre-wrap;">{{ item.message }}</div>
    </v-alert>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { getActivePinnedInfos, type PinnedInfo } from '@/services/bluesky';

const STORAGE_KEY = 'dismissed_pinned_infos';

const visible = ref<PinnedInfo[]>([]);

const getDismissed = (): Set<string> => {
  try {
    return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'));
  } catch {
    return new Set();
  }
};

const saveDismissed = (set: Set<string>) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
};

const dismiss = (item: PinnedInfo) => {
  visible.value = visible.value.filter(i => i.rkey !== item.rkey);
  const dismissed = getDismissed();
  // Store rkey + updatedAt so re-edits show the banner again
  dismissed.add(dismissKey(item));
  saveDismissed(dismissed);
};

// Key includes updatedAt so an edited announcement re-appears
const dismissKey = (item: PinnedInfo) => `${item.rkey}:${item.updatedAt || item.createdAt}`;

onMounted(async () => {
  try {
    const active = await getActivePinnedInfos();
    const dismissed = getDismissed();
    visible.value = active.filter(item => !dismissed.has(dismissKey(item)));
  } catch (e) {
    // Silently fail — banners are non-critical
  }
});
</script>
